import React, { useEffect, useReducer } from "react"

import { risksReducer } from "../reducers/risksReducer"
import { measuresReducer } from "../reducers/measuresReducer"
import { NumberOfTriesAction } from "../types/types"

export const useEventSource = ({
  dispatchNumberOfTries,
  companyDescription,
  projectDescription,
}: {
  dispatchNumberOfTries: (action: NumberOfTriesAction) => void
  companyDescription: string
  projectDescription: string
}) => {
  const [errors, setErrors] = React.useState<Event[]>([])
  const [measures, dispatchMeasure] = useReducer(measuresReducer, [])
  const [risks, dispatchRisk] = useReducer(risksReducer, [])

  const [isLoading, setIsLoading] = React.useState<boolean>(true)

  const isMounted = React.useRef(false)
  const sseRef = React.useRef<EventSource>()

  useEffect(() => {
    isMounted.current = true
    sseRef.current = new EventSource(
      `${window.DMAZE.appConfig.AI_API_BASE_URL}?CompanyDescription=${companyDescription}&ProjectDescription=${projectDescription}`
    )
    sseRef.current.addEventListener("ai-demo", (e) => {
      const parsedData = JSON.parse(e.data, (key, value) => {
        if (key === "id" || key === "parentid") {
          return parseInt(value, 10)
        }
        return value
      })
      if (parsedData.title && parsedData.parentid === 0) {
        if (isMounted.current) {
          dispatchRisk({ type: "PUSH", risk: parsedData })
        }
      } else if (parsedData.title && parsedData.parentid !== 0) {
        if (isMounted.current) {
          dispatchMeasure({ type: "PUSH", measure: parsedData })
        }
      } else if (parsedData.isdone === true) {
        dispatchNumberOfTries({
          type: "INCREMENT",
        })
        setIsLoading(false)
        if (isMounted.current) {
          setErrors([])
          if (sseRef.current) {
            sseRef.current.close()
          }
        }
      }
    })
    sseRef.current.onerror = (e) => {
      console.log("error", e)
      if (isMounted.current) {
        setErrors((errors) => [...errors, e])
        setIsLoading(false)
      }
    }

    return () => {
      isMounted.current = false
      setIsLoading(false)
      setErrors([])
      console.log("closing sse connection")
      if (sseRef.current) {
        sseRef.current.close()
      }
    }
  }, [companyDescription, dispatchNumberOfTries, projectDescription])

  return { errors, risks, measures, isLoading }
}
